<po-page-default p-title="Descobrir rubricas" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
        <span class="an an-magnifying-glass"></span>
        Rubricas do eSocial
      </span>

      <div class="po-lg-12 po-mb-4 destaque">
        <p class="po-font-text-large po-mb-1">
          Envie os arquivos do eSocial para listar as rubricas da empresa numa planilha.
        </p>
        <p>
          <b>
            A planilha já traz a correlação quando a mesma rubrica existe para outra empresa.
            Complete o que faltar e importe no cadastro de rubricas.
          </b>
        </p>
      </div>

      <div class="po-lg-6 po-md-12">
        <app-empresa-combo
          name="codiEmp"
          label="Empresa"
          [(ngModel)]="codiEmp"
          [disabled]="gerando">
        </app-empresa-combo>
      </div>

      <div class="po-lg-12">
        <po-upload
          #uploadEsocial
          [p-restrictions]="esocialRestrictions"
          p-size="medium"
          [p-drag-drop]="true"
          [p-multiple]="true"
          [p-drag-drop-height]="150"
          [p-url]="urlPlaceholder"
          [p-hide-send-button]="true"
          [p-disabled]="gerando"
          p-label="Arquivos do eSocial (.xml ou .zip)">
        </po-upload>
      </div>

      <po-button
        class="po-lg-4 po-mt-3"
        p-icon="an an-file-xls"
        p-label="Gerar planilha"
        (p-click)="gerarPlanilha()"
        [p-loading]="gerando"
        [p-disabled]="gerando">
      </po-button>

      <po-button
        class="po-lg-4 po-mt-3 po-ml-2"
        p-kind="secondary"
        p-icon="an an-arrow-left"
        p-label="Voltar ao cadastro"
        (p-click)="irParaCadastro()"
        [p-disabled]="gerando">
      </po-button>
    </po-container>
  </div>
</po-page-default>
